module.exports = __webpack_public_path__ + "img/bg2.8ab7ea13.png";